import React, { useCallback } from 'react'
import { t } from 'i18next'
import Quill from 'quill'
import { useLocation } from 'react-router-dom'
import { ROUTES, PDF_OPTIONS } from 'Utils/constants'
import { useSelector, useDispatch } from 'react-redux'
import { isAllowedCompany } from 'Utils/isAllowedCompany'
import { setPdfOption } from 'redux/actions/cotizacionActions'
import { CustomSwitch } from 'Components/Switch/CustomSwitch'
import './QuotationPdfOptions.css'

const AlignStyle = Quill.import('attributors/style/align')
Quill.register(AlignStyle, true)

const PdfOptionSwitch = ({ checked, onChange, label }) => (
  <div className="quotation-pdf-option">
    <div className="quotation-pdf-option-switch">
      <CustomSwitch
        width={31}
        height={18}
        checked={checked}
        onChange={onChange}
      />
    </div>
    <label className="quotation-pdf-option-switch-text">{label}</label>
  </div>
)

export const QuotationPdfOptions = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const currentPath = location.pathname

  const CompanyId = useSelector(state => state.company?.CompanyId)
  const { IsCatalog, IsService } = useSelector(
    state => state.cotizacion.QuoteHeader
  )

  const handleSwitch = useCallback(
    option => e => {
      dispatch(setPdfOption(option, e.target.checked))
    },
    [dispatch]
  )

  if (!currentPath.includes(ROUTES.generateQuote)) {
    return null
  }

  return (
    <div className="quotation-pdf-options">
      {/* The switch to generate catalog-type PDFs for Punto Cochez is disabled. */}
      {isAllowedCompany(CompanyId) && (
        <PdfOptionSwitch
          checked={IsCatalog}
          label={t('GENERATE_CATALOG_PDF')}
          onChange={handleSwitch(PDF_OPTIONS.IS_CATALOG)}
        />
      )}
      <PdfOptionSwitch
        checked={IsService}
        label={t('INCLUDE_ADDITIONAL_SERVICE_DETAILS')}
        onChange={handleSwitch(PDF_OPTIONS.IS_SERVICE)}
      />
    </div>
  )
}
